import { createFileRoute, Link } from '@tanstack/react-router';
import { seo } from '~/util';

export const Route = createFileRoute('/privacy')({
    head: () => ({
        meta: seo({
            title: 'Privacy Policy',
            description:
                'Privacy policy for the All Rated Extreme Demons List.',
        }),
    }),
    component: PrivacyPage,
});

function PrivacyPage() {
    return (
        <div className="mx-auto w-full max-w-5xl px-4 py-6">
            <div className="bg-background-dark/80 backdrop-blur-md rounded-xl p-6 md:p-8 shadow-md border border-gray-800">
                <article className="prose prose-invert max-w-none leading-5 [&>*+*]:mt-2 [&_a]:text-primary [&_a]:font-semibold [&_a]:hover:underline">
                    <h1>Privacy Policy</h1>
                    <p>
                        <strong>Last Updated: June 21, 2026</strong>
                    </p>

                    <br />

                    <p>
                        When you use the All Rated Extreme Demons List (AREDL)
                        website, we may collect information such as your Discord
                        account details for authentication, including your
                        Discord ID, username, and avatar. You may also choose to
                        add optional profile information, such as your country
                        of residence.
                    </p>
                    <p>
                        When you submit records, we collect the information you
                        provide through the submission form so that staff can
                        review your submission. This may include record details,
                        submission notes, links, or other evidence you choose to
                        submit. As stated in the{' '}
                        <Link to="/guidelines">submission guidelines</Link>, raw
                        footage submitted is kept confidential and is only
                        accessible to the AREDL list staff team.
                    </p>
                    <p>
                        For security and abuse prevention, we may collect basic
                        technical logs, such as IP addresses and request
                        activity.
                    </p>

                    <br />

                    <p>
                        Some temporary technical logs are kept for a limited
                        time (up to a month) to help with security and
                        moderation. Account information and submission history
                        are kept long-term for review purposes.{' '}
                    </p>

                    <p>
                        Users may request removal or redaction of their account
                        information, but some information may be kept where
                        needed for records, bans, or abuse prevention.
                    </p>

                    <br />

                    <p>
                        AREDL uses third-party services to operate the site.
                        These include Discord for authentication and Cloudflare
                        for hosting, security, and infrastructure. These
                        services may process information according to their own
                        privacy policies.
                    </p>

                    <br />

                    <p>
                        AREDL only uses cookies that are necessary for the site
                        to work. These cookies help keep you logged in and help
                        protect the site from abuse or bot traffic. We do not
                        use advertising or tracking cookies.
                    </p>

                    <br />

                    <p>AREDL is not intended for users under the age of 13.</p>
                    <p>
                        Because AREDL uses Discord for authentication, users
                        must also meet Discord&apos;s minimum age requirements.
                        If Discord&apos;s rules require a higher minimum age in
                        your country, that higher age requirement applies.
                    </p>
                    <p>
                        We do not knowingly collect personal information from
                        users who are not old enough to use AREDL or Discord. If
                        we become aware that an underage user has used the site,
                        we may restrict access to the account and remove or hide
                        related information where appropriate.
                    </p>

                    <br />
                    <p>
                        We may update this Privacy Policy from time to time.
                        When we do, the updated version will be posted on this
                        page.
                    </p>
                    <p>
                        By continuing to use the AREDL after changes are made,
                        you accept the updated policy.
                    </p>

                    <br />
                    <p>
                        For privacy questions, contact us through the AREDL
                        Discord server.
                    </p>
                </article>
            </div>
        </div>
    );
}
